import { BadgeCheck, Star } from "lucide-react";
import { getExplorePlanStatus, type ExplorePlanTier } from "@workspace/manual";

export default function FeaturePlanMarker({
  planTiers,
  currentTier,
  variant = "badge",
  testId,
  className = "",
}: {
  planTiers?: ExplorePlanTier[];
  currentTier?: string | null;
  variant?: "icon" | "badge";
  testId?: string;
  className?: string;
}) {
  const status = getExplorePlanStatus(planTiers, currentTier);
  if (!status) return null;

  const isUpgrade = status.status === "upgrade";
  const accessibleLabel = isUpgrade
    ? `More included with ${status.planLabel}`
    : "Included in your current plan";
  const Icon = isUpgrade ? Star : BadgeCheck;

  if (variant === "icon") {
    return (
      <span
        className={`inline-flex items-center justify-center ${
          isUpgrade ? "text-amber-400" : "text-emerald-400"
        } ${className}`}
        role="img"
        aria-label={accessibleLabel}
        title={accessibleLabel}
        data-testid={testId}
      >
        <Icon className="h-3.5 w-3.5" aria-hidden="true" />
      </span>
    );
  }

  return (
    <span
      className={`inline-flex max-w-full items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-medium leading-none ${
        isUpgrade
          ? "border-amber-400/30 bg-amber-400/10 text-amber-300"
          : "border-emerald-400/30 bg-emerald-400/10 text-emerald-300"
      } ${className}`}
      role="img"
      aria-label={accessibleLabel}
      title={accessibleLabel}
      data-testid={testId}
    >
      <Icon className="h-3 w-3 shrink-0" aria-hidden="true" />
      <span>{isUpgrade ? status.planLabel : "Included"}</span>
    </span>
  );
}
